import { ManageOrders, showMessage } from "../../Functionalities/Functions";
import { GET_API, PATCH_API } from "../../Functionalities/APIs";
import { orderEditsUrl, orderItemsAdminUrl } from "../../Constants/apiUrls";

// Who can be reached about the order besides the account's own mobile
// (backend orders/contact.py): the receiver's Indian number, and the WhatsApp
// number of a customer with no Indian number, who could only pay online.
export const whatsappLink = (number) => {
  const digits = String(number ?? "").replace(/\D/g, "");
  return digits ? `https://wa.me/${digits}` : null;
};

export const orderContactLines = (order) => {
  const lines = [];
  if (order?.receiver_phone) {
    lines.push({ label: "Receiver's phone", value: order.receiver_phone, href: `tel:${order.receiver_phone}` });
  }
  if (order?.whatsapp_number) {
    lines.push({ label: "WhatsApp", value: order.whatsapp_number, href: whatsappLink(order.whatsapp_number) });
  }
  return lines;
};

export const isContactAbroad = (order) => Boolean(order?.contact_abroad);

// restaurant_note is null on orders from customer builds with one note, shown to the restaurant and the rider alike.
export const orderNoteLines = (order) => {
  const lines = [];
  if (order?.restaurant_note) lines.push({ label: "For the restaurant", text: order.restaurant_note });
  if (order?.delivery_note) {
    const label = order.restaurant_note == null ? "For the restaurant and the delivery partner" : "For the delivery partner";
    lines.push({ label, text: order.delivery_note });
  }
  return lines;
};

export const canCompleteSelfPickup = (order) =>
  Boolean(
    order &&
      order.self_pickup &&
      !order.delivery_boy &&
      Number(order.status && order.status.id) === 2
  );

export const getOrderItemsAdmin = (orderId) => {
  return GET_API("", "order_id=" + orderId, orderItemsAdminUrl);
};

export const getOrderEdits = (orderId) => GET_API("", "order_id=" + orderId, orderEditsUrl);

export const updateOrderItems = (orderId, items, confirmAmountChange) => {
  let fdata = new FormData();
  fdata.append("order_id", orderId);
  fdata.append("items", JSON.stringify(items));
  if (confirmAmountChange) fdata.append("confirm_amount_change", "true");
  return PATCH_API(fdata, "", orderItemsAdminUrl);
};

export const changeOrderStatus = (stat) => {
  ManageOrders("", "patch", stat)
    .then((res) => {
      if (res.data.Status === true) {
        window.location.reload();
        showMessage(
          res.data.Message,
          "success",
          "Success!",
          "top",
          "top-right",
          0
        );
      } else {
        showMessage(res.data.Error, "danger", "Error!", "top", "top-right");
      }
    })
    .catch((err) =>
      showMessage("Error occured", "danger", "Error!", "top", "top-right")
    );
};
